import RankedMembers from './RankedMembers.component';

export default RankedMembers;
